import React from 'react';
import moment from 'moment';
import {
  DateField,
} from '@unite-us/ui';

export function init(Survey, isCreator) {
  const widget = {
    name: 'calendar',
    title: 'Calendar',
    isFit: (question) => question.getType() === 'text' && question.inputType === 'date',
    isDefaultRender: isCreator,
    iconName: 'icon-datepicker',
    defaultJSON: {
      type: "text",
      inputType: "date",
    },
    widgetIsLoaded: () => true,
    activatedByChanged: () => {
      Survey.JsonObject.metaData.addClass('calendar', [], null, 'text');
    },
    render: (question) => (
      <DateField
        disabled={question.readOnly}
        dateFormat="MM/DD/YYYY"
        isUtc={false}
        value={question.value ? moment(question.value, 'YYYY-MM-DD') : null}
        onChange={(date) => {
          if (date)
            question.setValueCore(moment.unix(date).format('YYYY-MM-DD'));
        }}
      />
    ),
  };

  Survey.CustomWidgetCollection.Instance.addCustomWidget(widget, 'customtype');
}
